import { render, staticRenderFns } from "./OutcomesList.vue?vue&type=template&id=56f3ddf8&"
import script from "./OutcomesList.vue?vue&type=script&lang=js&"
export * from "./OutcomesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports